import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useSelector } from 'react-redux';
import { formatPrice, formatPricewithdecimal } from "../NumberFormat";
import { withTranslation } from "react-i18next";
import ErrorCodePopup from "./ErrorCodePopup";

const MacauShioSuccessPopup = (props) => {
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const { onClose, response } = props;

  const [successData, setDataSuccess] = useState([]);
  const [faildData, setDataFaild] = useState([]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState('')

  useEffect(() => {
    if (response.length > 0) {
      const gametype = response[0].gametype;

      if (response[0].datasuccess) {
        if (gametype === "quickbuy") {
          setDataSuccess(response[0].datasuccess[gameId]['4d3d2d']);
        } else {
          setDataSuccess(response[0].datasuccess[gameId]);
        }
      }

      if (response[0].datafailed) {
        setDataFaild(response[0].datafailed[gameId]);
      }
    }
  }, [response, gameId]);

  const handlePopupOpen = (redValue) => {
    let message;
    let code = '';
    code = 'code' + redValue;
    let popupMessage = props.t(code);
    setPopupMessage(popupMessage);
    setIsPopupOpen(true);
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
    setPopupMessage('');
  };

  // const game_code = response[0].gameType == 'polatarung' ? response[0].game_code : '';


  return (
    <div className="overlay">
      <div className='overlay_innerDiv' onClick={onClose}></div>
      <div className="informasi_popup">
        <div className="betdeskon_popup_header">
          <p className="process_txt">
            {props.t('process_done')} ({response[0].processLabel ? response[0].processLabel : ''} - {response[0].game_name})
          </p>
          <button className="betdeskon_popup-close" onClick={onClose}>
          <IoMdClose className="btnclose"/>
          </button>
        </div>
        {faildData.length > 0 && (
          <>
            <div className="result_txt">
              {props.t('period')} <span className="header_txt">{response[0].nextPeriode} - {response[0].game_code}</span> Cancelled
            </div>
            <div className="betdeskonwrapper">
              <div className="betdeskon_container">
                <div className="betdeskoncontainer">
                  <table>
                    <thead>
                      <tr className="Heading">
                        <th>No</th>
                        <th>{props.t('bet')} 1</th>
                        <th>{props.t('bet')} 2</th>
                        {/* <th>Position</th> */}
                        <th>{props.t('amount')}</th>
                        <th>{props.t('error_code')}</th>
                        <th>{props.t('description')}</th>
                      </tr>
                    </thead>
                    <tbody className="scrollable-tbody">
                      {faildData?.map((item, index) => (
                        <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                          <td className="inputs">{index + 1}</td>
                          <td className="inputs">
                            <strike>{item.bet}</strike>
                          </td>
                          <td className="inputs">
                            <strike>{item.bet}</strike>
                          </td>
                          {/* <td className="inputs">
                            <strike>{item.posisi === "-" ? "4D" : item.posisi}</strike>
                          </td> */}
                          <td className="inputs">
                            <strike>{item.amount}</strike>
                          </td>
                          <td className="inputs" style={{ cursor: "pointer" }}>
                            {/* <a >Click Here({item.red})</a> */}
                            <a className="link" onClick={() => handlePopupOpen(item.red)}>
                              {props.t('click_here')} ({item.red})
                            </a>
                          </td>
                          <td className="inputs" style={{ color: 'red' }}>
                            {item.red == 14 ? props.t("Removed") : props.t("Eliminate")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}

        {successData?.length > 0 && (
          <>
            <div className="result_txt">
              {props.t('period')} <span className="header_txt">{response[0].nextPeriode} - {response[0].game_code}</span> Success
            </div>
            <div className="betdeskonwrapper">
              <div className="betdeskon_container">
                <div className="betdeskoncontainer">
                  <table>
                    <thead>
                      <tr className="Heading">
                        <th>No</th>
                        <th>{props.t('bet')} 1</th>
                        <th>{props.t('bet')} 2</th>
                        {/* <th>Position</th> */}
                        <th>{props.t('amount')}</th>
                        <th>{props.t('discount')} (%)</th>
                        <th>{props.t('pay')}</th>
                        <th>{props.t('totalWin')}</th>
                      </tr>
                    </thead>
                    <tbody className="scrollable-tbody">
                      {successData?.map((item, index) => (
                        <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                          <td className="inputs">{index + 1}</td>
                          <td className="inputs">{item.bet}</td>
                          <td className="inputs">{item.bet2}</td>
                          {/* <td className="inputs">{item.posisi === "-" ? "4D" : item.posisi}</td> */}
                          <td className="inputs">{formatPrice(item.amount)}</td>
                          <td className="inputs">{item.disc}</td>
                          <td className="inputs">{formatPricewithdecimal(item.bayar.toFixed(2))}</td>
                          <td className="inputs">{formatPricewithdecimal(item.totalWin)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="total_plyer_count">Total {props.t('player_pay')}: {formatPricewithdecimal(response[0].totalbayar)}</div>
      </div>
      {isPopupOpen &&
        (<ErrorCodePopup onClose={handlePopupClose} message={popupMessage} />)
      }
    </div>
  );
};

export default withTranslation()(MacauShioSuccessPopup);
